<template>
  <div id="timer" class="w100 btn">
    <div class="text-nowrap">
      <i class="fa fa-clock mr-2" aria-hidden="true"></i>
      {{ time }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      duration: 0,
      time: "00:00:00",
      pause: false,
      percent: 0,
    };
  },
  beforeDestroy() {},
  methods: {
    startTimer() {
      setTimeout(() => {
        this.duration += 1;
        if (!this.pause) this.startTimer();
      }, 1000);
      var date = new Date(0);
      date.setSeconds(this.duration); // specify value for SECONDS here
      this.time = date.toISOString().substr(11, 8);
    },
    onReset() {
      this.duration = 0;
      this.pause = false;
      this.time = "00:00:00";
    },
    onResume() {
      this.pause = false;
    },
    onPause() {
      this.pause = true;
    },
  },
};
</script>
<style scoped>
#timer {
  color: #fff;
  width: 200px;
  font-size: 22px;
  padding: 5px 15px 5px 15px;
  -webkit-box-shadow: inset 0px 0px 8px 5px rgba(227, 227, 227, 0.63);
  box-shadow: inset 0px 0px 8px 5px rgba(227, 227, 227, 0.63);
}
</style>